var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-page"},[_c('div',{staticClass:"top-title"},[_vm._v("党建VR体验")]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/dangVR/1.jpg")}})]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/dangVR/2.jpg")}})]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/dangVR/3.jpg")}})])])
}]

export { render, staticRenderFns }